import { render, staticRenderFns } from "./TheNewUserDrawer.vue?vue&type=template&id=232668a6&scoped=true"
import script from "./TheNewUserDrawer.vue?vue&type=script&lang=js"
export * from "./TheNewUserDrawer.vue?vue&type=script&lang=js"
import style0 from "./TheNewUserDrawer.vue?vue&type=style&index=0&id=232668a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232668a6",
  null
  
)

export default component.exports